<template>
    <div id="ItemCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="itemHeader" v-if="$route.params.id > 0">Update Part</span>
                    <span class="page-title" id="itemHeader" v-else>Add Part</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackItemList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content component-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ItemForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="category_id">Category:</label>
                                        <v-select v-model="category_id" name="category_id" placeholder="Select Category."
                                                label="text"
                                                :options="categoryArr">
                                        </v-select>
                                        <div class="field-error">{{ categoryerrors }}</div>
                                    </div>

                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="code">#Part:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{ codeerrors }}</div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="vendor_item_number">Part#:</label>
                                        <input type="text" class="form-control" v-model="stock_part_number" id="stock_part_number" placeholder="Enter Stock Part#" name="stock_part_number">
                                        <div class="field-error">{{ stock_part_number_error }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Description:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{ nameerrors }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="tax_id">Tax:</label>
                                        <v-select v-model="tax_id" name="tax_id" placeholder="Select Tax."
                                                label="text"
                                                :options="taxArr">
                                        </v-select>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="parent_id">Core Part:</label>
                                        <v-select v-model="parent_id" name="parent_id"
                                                label="text" :filterable="false" :options="parentArr"
                                                @search="onSearchParent"
                                                placeholder="Select Core Part Code or Name" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Core Part Code or Name...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label" for="vendor_id">Vendor:</label>
                                        <v-select v-model="vendor_id" name="vendor_id"
                                                label="text" :filterable="false" :options="vendorArr"
                                                @search="onSearchVendor"
                                                placeholder="Select Vendor Code or Name" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Vendor Code or Name...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vendor_item_number">Vendor Part#:</label>
                                        <input type="text" class="form-control" v-model="vendor_item_number" id="vendor_item_number" placeholder="Enter Vendor Part#" name="vendor_item_number">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="manufacturer_item_number">Manufacturer Part#:</label>
                                        <input type="text" class="form-control" v-model="manufacturer_item_number" id="manufacturer_item_number" placeholder="Enter Manufacturer Part#" name="manufacturer_item_number">
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="freeze_flag">Freeze Flag:</label>
                                        <input type="text" class="form-control" v-model="freeze_flag" id="freeze_flag" placeholder="Enter Freeze Flag" name="freeze_flag">
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label" for="manufacturer_id">Manufacturer:</label>
                                        <v-select v-model="manufacturer_id" name="manufacturer_id" placeholder="Select Manufacturer."
                                                label="text"
                                                :options="manufacturerArr">
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="warranty_id">Warranty:</label>
                                        <v-select v-model="warranty_id" name="warranty_id" placeholder="Select Warranty."
                                                label="text"
                                                :options="warrantyArr">
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vmrsId">VMRS Code:</label>
                                        <v-select v-model="vmrsId" name="vmrsId"
                                                label="text" :filterable="false" :options="vmrsArr"
                                                @search="onSearchVMRS"
                                                placeholder="Select VMRS Code or Name" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search VMRS Code or Name...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="stock_unit_id">Stock UOM:</label>
                                        <v-select v-model="stock_unit_id" name="stock_unit_id" placeholder="Select Stock UOM."
                                                label="text"
                                                :options="stockunitArr">
                                        </v-select>
                                        <div class="field-error">{{ stockuniterrors }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="purchase_unit_id">Purchase UOM:</label>
                                        <v-select v-model="purchase_unit_id" name="purchase_unit_id" placeholder="Select Purchase UOM."
                                                label="text"
                                                :options="purchaseunitArr">
                                        </v-select>
                                        <div class="field-error">{{ purchaseuniterrors }}</div>
                                    </div>

                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="item_measurement_id">Part UOM:</label>
                                        <v-select v-model="item_measurement_id" name="item_measurement_id" placeholder="Select Part UOM."
                                                label="text"
                                                :options="itemmeasurementArr">
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div> -->

                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="location_id">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{locationerrors}}</div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label" for="onhand_min_qty">Onhand Min Qty:</label>
                                        <input type="text" class="form-control" v-model="onhand_min_qty" id="onhand_min_qty" placeholder="Enter Onhand Min Qty" name="onhand_min_qty" @keypress="isAmountCheck($event)">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="onhand_max_qty">Onhand Max Qty:</label>
                                        <input type="text" class="form-control" v-model="onhand_max_qty" id="onhand_max_qty" placeholder="Enter Onhand Max Qty" name="onhand_max_qty" @keypress="isAmountCheck($event)">
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="metric_type_id">Metric Type:</label>
                                        <v-select v-model="metric_type_id" name="metric_type_id" placeholder="Select Metric Type."
                                                label="text"
                                                :options="metricArr">
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="replenishment_method_id">Replenishment Method:</label>
                                        <v-select v-model="replenishment_method_id" name="replenishment_method_id" placeholder="Select Replenishment Method."
                                                label="text"
                                                :options="replenishmentArr">
                                        </v-select>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label">Expense Item</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="expense1_item">
                                                    Yes
                                                    <input type="radio" v-model="expense_item" :value="1" id="expense1_item" name="expense_item" v-on:click="checkSelected($event)">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="expense2_item">
                                                    No
                                                    <input type="radio" v-model="expense_item" :value="0" id="expense2_item" name="expense_item" v-on:click="checkSelected($event)">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col form-group">
                                      <label class="control-label">Is Non Inventory Item?</label>
                                      <div class="custome-radiobtn">
                                          <div class="form-check form-check-inline">
                                              <label class="boolean optional radio-custom" for="is_non_inv_item1">
                                                  Yes
                                                  <input type="radio" v-model="is_non_inv_item" :value="1" id="is_non_inv_item1" name="is_non_inv_item" v-on:click="checkSelected($event)">
                                                  <span class="checkmark"></span>
                                              </label>
                                          </div>
                                          <div class="form-check form-check-inline">
                                              <label class="boolean optional radio-custom" for="is_non_inv_item1">
                                                  No
                                                  <input type="radio" v-model="is_non_inv_item" :value="0" id="is_non_inv_item1" name="is_non_inv_item" v-on:click="checkSelected($event)">
                                                  <span class="checkmark"></span>
                                              </label>
                                          </div>
                                      </div>
                                  </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="location_row">Location Row:</label>
                                        <input type="text" class="form-control" v-model="location_row" id="location_row" placeholder="Enter Location Row" name="location_row">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="location_bin">Location Bin:</label>
                                        <input type="text" class="form-control" v-model="location_bin" id="location_bin" placeholder="Enter Location Bin" name="location_bin">
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="location_shelf">Location Shelf:</label>
                                        <input type="text" class="form-control" v-model="location_shelf" id="location_shelf" placeholder="Enter Location Shelf" name="location_shelf">
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="location_shelf">Base Price:</label>
                                        <input type="text" class="form-control" v-model="base_price" id="base_price" placeholder="Enter Base Price" name="base_price" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{base_price_error_msg}}</div>
                                    </div> -->
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <div class="custom-checkbox">
                                            <div>
                                                <label for="is_multiple_location" class="checkbox-custom"> Multiple Location
                                                <input type="checkbox" v-model="is_multiple_location" id="is_multiple_location" name="is_multiple_location">
                                                <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div>
                                                <label for="is_allow_substitute" class="checkbox-custom">Allow Substitute
                                                <input type="checkbox" v-model="is_allow_substitute" id="is_allow_substitute" name="is_allow_substitute">
                                                <span class="checkmark"></span>
                                                </label>
                                                </div>
                                            <div>
                                                <label for="is_serialized" class="checkbox-custom">Serialized
                                                <input type="checkbox" v-model="is_serialized" id="is_serialized" name="is_serialized">
                                                <span class="checkmark"></span>
                                                </label>
                                                </div>
                                            <div>
                                                <label for="is_pst_exempt" class="checkbox-custom">PST Exempt
                                                <input type="checkbox" v-model="is_pst_exempt" id="is_pst_exempt" name="is_pst_exempt">
                                                <span class="checkmark"></span>
                                                </label>
                                                </div>
                                            <div>
                                                <label for="is_rebuildable" class="checkbox-custom">Rebuildable
                                                <input type="checkbox" v-model="is_rebuildable" id="is_rebuildable" name="is_rebuildable">
                                                <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group" v-if="$route.params.id > 0">
                                        <label class="control-label" for="barcode">Barcode:</label>
                                        <img :src="'data:image/png;base64,'+ barcode" alt="barcode"/>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createItemBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateItem" >
                                    <i class="fp-relaod"> </i>  Update
                                    </button>

                                    <button type="submit" id="createItemBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateItem" >
                                    <i class="fp-save"> </i>  Save
                                    </button>

                                    <button type="submit" id="createAndContinueItemBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateItem(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>

                                    <button type="submit" id="cancelItemBtn" class="btn btn-tertiary" v-on:click.prevent="BackItemList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
export default {
  name: "ItemCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Part | " +process.env.COPYRIGHT_NAME : "Add Part | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    category_id: null,
    categoryArr: [],
    categoryerrors: "",
    name: "",
    nameerrors: "",
    code: "",
    codeerrors: "",
    barcode:"",
    // description: "",
    // parent_id: null,
    parentArr: [],
    vendor_id: null,
    vendorArr: [],
    expense_item: "0",
    is_non_inv_item: "0",
    expenseValue: 0,
    // depriciable: 0,
    manufacturer_id: null,
    manufacturerArr: [],
    tax_id: null,
    taxArr: [],
    manufacturer_item_number: "",
    vendor_item_number: "",
    warranty_id: null,
    warrantyArr: [],
    stock_unit_id: null,
    stockunitArr: [],
    stockuniterrors: "",
    purchase_unit_id: null,
    purchaseuniterrors: "",
    purchaseunitArr: [],
    onhand_min_qty: "",
    onhand_max_qty: "",
    // item_measurement_id: null,
    // itemmeasurementArr: [],
    location_id: null,
    locationArr: [],
    is_multiple_location: false,
    is_allow_substitute: false,
    is_serialized: false,
    is_pst_exempt: false,
    is_rebuildable: false,
    // freeze_flag: "",
    // metric_type_id: null,
    // metricArr: [],
    location_row: "",
    location_shelf: "",
    location_bin: "",
    // replenishment_method_id: null,
    // replenishmentArr: [],
    loading:false,
    locationerrors:'',
    vmrsId:null,
    vmrsArr:[],
    // base_price:'',
    // base_price_error_msg:'',
    stock_part_number:"",
    stock_part_number_error:""
  }),
  watch:{
    //check permission change
    permissions: function (permissions) {

        var self = this;
        if (permissions.length > 0) {
            for (var i = 0; i < permissions.length; i++) {
                if (permissions[i].name == 'add_component' ) {
                    self.cantAccessPage = true;
                }
            }
        }

    }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        // console.log("Default " + self.expenseValue);
        self.getPermissions();
        self.loadItemSearchData();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {

            self.loadItem();

        }
  },
  methods: {

    onSearchVendor(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vendor', '');
        }
    },
    onSearchVMRS(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vmrs', '');
        }
    },

    onSearchParent(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'parent', '');
        }
    },
    BackItemList() {
      var self = this;
      self.$router.push("/part/list");
    },
      checkSelected: function(e) {
        console.log(e);
          var self = this;
          self.expenseValue=e.target.value;
          // if (e.target.value) {
          //
          //     self.expenseValue = 1;
          // }else{
          //     self.expenseValue = 0;
          // }
      },
    /*checkSelected() {
        var self = this;
        if (self.expense_item != true) {
            self.expenseValue = 1;
            // console.log("IF " + self.expenseValue);
        } else {
            self.expenseValue = 0;
            // console.log("else " + self.expenseValue);
        }
    },*/

    loadItemSearchData() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/component/search",
           type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType: 'json',
            success: function (data) {

                if (data.status == "success") {

                    self.categoryArr = data.ItemCategory;
                    // self.vendorArr = data.vendor;
                    self.manufacturerArr = data.ItemManufacturer;
                    self.taxArr = data.Tax;
                    self.warrantyArr = data.Warranty;
                    self.stockunitArr = data.MeasurementUnit;
                    self.purchaseunitArr = data.MeasurementUnit;
                    self.itemmeasurementArr = data.MeasurementUnit;
                    self.locationArr = data.Location;
                    self.replenishmentArr = data.Replenishment;
                    self.metricArr = data.MetricType;

                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'component-search')
            }
        });
    },

    CreateItem(flag) {
        var self = this;
        var error = false;

        // self.code = self.code.trim();
        self.stock_part_number = self.stock_part_number.trim();

        self.nameerrors = "";
        self.codeerrors = "";
        self.categoryerrors = "";
        self.stockuniterrors = "";
        self.purchaseuniterrors = "";
        self.base_price_error_msg = '';
        self.stock_part_number_error = "";

        // var checkNumber = /^[0-9]+(\.[0-9]+)?$/;
        // if (self.base_price == null || self.base_price == "") {
        //     self.base_price_error_msg = "Base Price Required.";
        //     error = true;
        // } else {

            //check amount is valid or not
            // if ( !String(self.base_price).match(checkNumber) ) {
            //     self.base_price_error_msg = "Base Price is not valid.";
            //     error = true;
            // }
        //}

        // if (self.location_id == null) {

        //     self.location_id = "";
        // }
        // if (self.location_id == null || self.location_id == '' || !self.location_id.value) {
        //     self.locationerrors = "Location Required.";
        //     error = true;
        // }

        // if (!self.name || self.name == null || self.name == "") {
        //     self.nameerrors = "Name Required.";
        //     error = true;
        // }

        // if (!self.code || self.code == null || self.code == "") {
        //     self.codeerrors = "Code Required.";
        //     error = true;
        // }

        if (self.category_id == null || !self.category_id.value) {
            self.categoryerrors = "Category Required.";
            error = true;
        }

        if (self.stock_unit_id == null || !self.stock_unit_id.value) {
            self.stockuniterrors = "Stock UOM Required.";
            error = true;
        }

        if (self.purchase_unit_id == null || !self.purchase_unit_id.value) {
            self.purchaseuniterrors = "Purchase UOM Required.";
            error = true;
        }

        if (!self.stock_part_number || self.stock_part_number == null || self.stock_part_number.trim() == "") {
            self.stock_part_number_error = "Stock Part Number Required.";
            error = true;
        }

        if (!error) {

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createItemBtn").val("Updating ...");
                $("#createItemBtn").prop("disabled", true);
                $("#cancelItemBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueItemBtn").val("Saving ...");
                    $("#createItemBtn").prop("disabled", true);
                    $("#createAndContinueItemBtn").prop("disabled", true);
                    $("#cancelItemBtn").prop("disabled",true);

                }else{

                    $("#createItemBtn").val("Saving ...");
                    $("#createItemBtn").prop("disabled", true);
                    $("#createAndContinueItemBtn").prop("disabled", true);
                    $("#cancelItemBtn").prop("disabled",true);
                }
            }

            var fields = $("#ItemForm").serializeArray();
            fields.push({ name: "id", value: segments[3] });
            fields.push({ name: "expense_item", value: self.expenseValue });
            fields.push({ name: "is_non_inv_item", value: self.is_non_inv_item });
            if(self.vmrsId == null) {
                fields.push({ name: "vmrsId", value: '' });
            } else {
                fields.push({ name: "vmrsId", value: self.vmrsId.value });
            }
            // fields.push({ name: "vmrsId", value: self.vmrsId.value });
            // fields.push({ name: "depriciable", value: self.depriciable });
            fields.push({ name: "category_id", value: self.category_id.value });
            fields.push({ name: "stock_unit_id", value: self.stock_unit_id.value });
            fields.push({ name: "purchase_unit_id", value: self.purchase_unit_id.value });
            // if ( self.location_id == '' ) {

            //     fields.push({ name: "location_id", value: self.location_id });
            // }else{

            //     fields.push({ name: "location_id", value: self.location_id.value });

            // }
            // fields.push({ name: "metric_type_id", value: self.metric_type_id.value });

            if(self.is_multiple_location == true) {
                fields.push({ name: "is_multiple_location", value: 1 });
            } else {
                fields.push({ name: "is_multiple_location", value: 0 });
            }

            if(self.is_allow_substitute == true) {
                fields.push({ name: "is_allow_substitute", value: 1 });
            } else {
                fields.push({ name: "is_allow_substitute", value: 0 });
            }

            if(self.is_serialized == true) {
                fields.push({ name: "is_serialized", value: 1 });
            } else {
                fields.push({ name: "is_serialized", value: 0 });
            }

            if(self.is_pst_exempt == true) {
                fields.push({ name: "is_pst_exempt", value: 1 });
            } else {
                fields.push({ name: "is_pst_exempt", value: 0 });
            }

            if(self.is_rebuildable == true) {
                fields.push({ name: "is_rebuildable", value: 1 });
            } else {
                fields.push({ name: "is_rebuildable", value: 0 });
            }

            /* fields.push({ name: "is_multiple_location", value: self.is_multiple_location });
            fields.push({ name: "is_allow_substitute", value: self.is_allow_substitute });
            fields.push({ name: "is_serialized", value: self.is_serialized });
            fields.push({ name: "is_pst_exempt", value: self.is_pst_exempt });
            fields.push({ name: "is_rebuildable", value: self.is_rebuildable }); */

            // fields.push({ name: "replenishment_method_id", value: self.replenishment_method_id.value });

            if (self.vendor_id == null) {
                fields.push({name: "vendor_id", value: ""});
            } else{
                fields.push({name: "vendor_id", value: self.vendor_id.value});
            }
            // if (self.parent_id == null) {
            //     fields.push({name: "parent_id", value: ""});
            // } else{
            //     fields.push({name: "parent_id", value: self.parent_id.value});
            // }

            if (self.manufacturer_id == null) {
                fields.push({name: "manufacturer_id", value: ""});
            } else{
                fields.push({name: "manufacturer_id", value: self.manufacturer_id.value});
            }

            if (self.tax_id == null) {
                fields.push({name: "tax_id", value: ""});
            } else{
                fields.push({name: "tax_id", value: self.tax_id.value});
            }

            if (self.warranty_id == null) {
                fields.push({name: "warranty_id", value: ""});
            } else{
                fields.push({name: "warranty_id", value: self.warranty_id.value});
            }

            // if (self.item_measurement_id == null) {
            //     fields.push({name: "item_measurement_id", value: ""});
            // } else{
            //     fields.push({name: "item_measurement_id", value: self.item_measurement_id.value});
            // }

            // if (self.location_id == null) {
            //     fields.push({name: "location_id", value: ""});
            // } else{
            //     fields.push({name: "location_id", value: self.location_id.value});
            // }

            // if (self.replenishment_method_id == null) {
            //     fields.push({name: "replenishment_method_id", value: ""});
            // } else{
            //     fields.push({name: "replenishment_method_id", value: self.replenishment_method_id.value});
            // }

            // if (self.metric_type_id == null) {
            //     fields.push({name: "metric_type_id", value: ""});
            // } else{
            //     fields.push({name: "metric_type_id", value: self.metric_type_id.value});
            // }

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/component/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createItemBtn").val("Update");
                        $("#createItemBtn").prop("disabled", false);
                        $("#cancelItemBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueItemBtn").val("Save and Continue");
                            $("#createItemBtn").prop("disabled", false);
                            $("#createAndContinueItemBtn").prop("disabled", false);
                            $("#cancelItemBtn").prop("disabled",false);

                        }else{

                            $("#createItemBtn").val("Save");
                            $("#createItemBtn").prop("disabled", false);
                            $("#createAndContinueItemBtn").prop("disabled", false);
                            $("#cancelItemBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#ItemForm").trigger("reset");
                            self.category_id = null;
                            // self.categoryArr = "";
                            self.code = "";
                            self.name = "";
                            self.vmrsId = null;
                            // self.description = "";
                            // self.parent_id = null;
                            self.vendor_id = null;
                            // self.vendorArr = "";
                            self.expenseValue = "";
                            self.expense_item = "";
                            self.is_non_inv_item = "";
                            // self.depriciable = "";
                            self.manufacturer_id = null;
                            // self.manufacturerArr = "";
                            self.tax_id = null;
                            // self.taxArr = "";
                            self.manufacturer_item_number = "";
                            self.vendor_item_number = "";
                            self.warranty_id = null;
                            // self.warrantyArr = "";
                            self.stock_unit_id = null;
                            // self.stockunitArr = "";
                            self.purchase_unit_id = null;
                            // self.purchaseunitArr = "";
                            self.onhand_min_qty = "";
                            self.onhand_max_qty = "";
                            // self.item_measurement_id = null;
                            self.location_id = null;
                            self.is_multiple_location = 0;
                            self.is_allow_substitute = 0;
                            self.is_serialized = 0;
                            self.is_pst_exempt = 0;
                            self.is_rebuildable = 0;
                            // self.metric_type_id = null;
                            // self.replenishment_method_id = null;
                            self.location_row = "";
                            self.location_shelf = "";
                            self.location_bin = "";
                            // self.freeze_flag = "";
                            // self.base_price = '';

                        }else{
                            self.$router.push("/part/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createItemBtn").val("Update");
                        $("#createItemBtn").prop("disabled", false);
                        $("#cancelItemBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#ItemForm").trigger("reset");


                            $("#createAndContinueItemBtn").val("Save and Continue");
                            $("#createItemBtn").prop("disabled", false);
                            $("#createAndContinueItemBtn").prop("disabled", false);
                            $("#cancelItemBtn").prop("disabled",false);

                        }else{

                            $("#createItemBtn").val("Save");
                            $("#createItemBtn").prop("disabled", false);
                            $("#createAndContinueItemBtn").prop("disabled", false);
                            $("#cancelItemBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'component-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }

    },

    loadItem() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/component/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {

                    if(data.content.category_id == null) {
                        self.category_id = null;
                    }else{
                        self.category_id = {value: data.content.category_id, text: self.titleCase(data.content.icName + " (" + data.content.icCode +")")};
                    }

                    if(data.content.category_id == null) {
                        self.category_id = null;
                    }else{
                        self.category_id = {value: data.content.category_id, text: self.titleCase(data.content.icName + " (" + data.content.icCode +")")};
                    }

                    if(data.content.vmrsPrimary == null) {
                        self.vmrsId = null;
                    }else{
                        self.vmrsId = {value: data.content.vmrsId, text: data.content.vmrsPrimary +data.content.vmrsSubsys+ data.content.vmrsSubCompCode+" | "+data.content.vmrsSubCompDesc};
                    }
                    self.barcode = data.content.barcode;
                    self.name = data.content.name;
                    self.code = data.content.code;
                    // self.description = data.content.description;

                    if(data.content.vendor_id == null) {
                        self.vendor_id = null;
                    }else{
                        self.vendor_id = {value: data.content.vendor_id, text: self.titleCase(data.content.veName + " (" + data.content.veCode +")")};
                    }

                    self.expenseValue = self.expense_item = data.content.expense_item;
                    // self.depriciable = data.content.depriciable;

                    if(data.content.manufacturer_id == null) {
                        self.manufacturer_id = null;
                    }else{
                        self.manufacturer_id = {value: data.content.manufacturer_id, text: self.titleCase(data.content.imCode+ " (" + data.content.imCode +")")};
                    }

                    if(data.content.tax_id == null) {
                        self.tax_id = null;
                    }else{
                        self.tax_id = {value: data.content.tax_id, text: self.titleCase(data.content.taName + " (" + data.content.taValue +")")};
                    }

                    self.manufacturer_item_number = data.content.manufacturer_item_number;
                    self.vendor_item_number = data.content.vendor_item_number;

                    if(data.content.warranty_id == null) {
                        self.warranty_id = null;
                    }else{
                        self.warranty_id = {value: data.content.warranty_id, text: self.titleCase(data.content.waDescription + " (" + data.content.waCode +")")};
                    }

                    if(data.content.stock_unit_id == null) {
                        self.stock_unit_id = null;
                    }else{
                        self.stock_unit_id = {value: data.content.stock_unit_id, text: self.titleCase(data.content.muName + " (" + data.content.muSymbol +")")};
                    }

                    if(data.content.purchase_unit_id == null) {
                        self.purchase_unit_id = null;
                    }else{
                        self.purchase_unit_id = {value: data.content.stock_unit_id, text: self.titleCase(data.content.mu1Name + " (" + data.content.mu1Symbol +")")};
                    }

                    self.onhand_min_qty = data.content.onhand_min_qty;
                    self.onhand_max_qty = data.content.onhand_max_qty;

                    // if(data.content.item_measurement_id == null) {
                    //     self.item_measurement_id = null;
                    // }else{
                    //     self.item_measurement_id = {value: data.content.item_measurement_id, text: self.titleCase(data.content.imName + " (" + data.content.imSymbol +")")};
                    // }

                    if(data.content.location_id == null) {
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.locName)};
                    }

                    // if(data.content.metric_type_id == null) {
                    //     self.metric_type_id = null;
                    // }else{
                    //     self.metric_type_id = {value: data.content.metric_type_id, text: self.titleCase(data.content.metricName)};
                    // }

                    // if(data.content.replenishment_method_id == null) {
                    //     self.replenishment_method_id = null;
                    // }else{
                    //     self.replenishment_method_id = {value: data.content.replenishment_method_id, text: self.titleCase(data.content.repName)};
                    // }

                    if(data.content.is_multiple_location == 1) {
                        self.is_multiple_location = true;
                    } else {
                        self.is_multiple_location = false;
                    }

                    if(data.content.is_allow_substitute == 1) {
                        self.is_allow_substitute = true;
                    } else {
                        self.is_allow_substitute = false;
                    }

                    if(data.content.is_serialized == 1) {
                        self.is_serialized = true;
                    } else {
                        self.is_serialized = false;
                    }

                    if(data.content.is_pst_exempt == 1) {
                        self.is_pst_exempt = true;
                    } else {
                        self.is_pst_exempt = false;
                    }

                    if(data.content.is_rebuildable == 1) {
                        self.is_rebuildable = true;
                    } else {
                        self.is_rebuildable = false;
                    }

                    self.is_non_inv_item = data.content.is_non_inv_item;

                    // self.freeze_flag = data.content.freeze_flag;

                    if (data.content.location_row == 0) {
                        self.location_row = "";
                    } else{
                        self.location_row = data.content.location_row;
                    }

                    if (data.content.location_bin == 0) {
                        self.location_bin = "";
                    } else{
                        self.location_bin = data.content.location_bin;
                    }

                    self.location_shelf = data.content.location_shelf;
                    // self.base_price = data.content.base_price;
                    if(data.content.stock_part_number != null && data.content.stock_part_number != "") {
                        self.stock_part_number = data.content.stock_part_number;
                    }else{
                        self.stock_part_number = data.content.code;
                    }

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'component-by-id')
            }
        });
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ComponentCreate.vue